import React from "react";
import dev from "../../../Images/dev.svg";
import generate from "../../../Images/generativeai.svg";
import sap from "../../../Images/sap.svg";
import servicesss from "../../../Images/itservices.svg";
import itcon from "../../../Images/it.svg";
import cloudimgdata from "../../../Images/cloud services.svg";
import "./Service.css";
import { useNavigate } from "react-router-dom";

const Servicestep = () => {
  const navigate = useNavigate();
  const stepsData = [
    {
      id: 1,
      icons: itcon,
      title: "IT Consulting",
      description:
        "Providing expert advice to optimize your IT infrastructure and align it with your business goals.",
      brandTag: ["IT Strategy", "Infrastructure Optimization", "Business Alignment"],
      onclick: () => {
        navigate("/servicepage/itconsulting");
      },
      active: true,
    },
    {
      id: 2,
      icons: servicesss,
      title: "IT Services",
      description:
        "Delivering comprehensive IT solutions to enhance your operational efficiency and productivity.",
      brandTag: ["Managed Services", "Technical Support", "System Integration"],
      onclick: () => {
        navigate("/servicepage/itservices");
      },
      active: false,
    },
    {
      id: 3,
      icons: dev,
      title: "Mobile App & Website Development",
      description:
        "Building responsive websites and mobile applications tailored to your business needs.",
      brandTag: ["App Design", "Web Development", "UI/UX"],
      onclick: () => {
        navigate("/servicepage/mobileappandwebdevelopment");
      },
      active: false,
    },
    {
      id: 4,
      icons: cloudimgdata,
      title: "Cloud Services",
      description:
        "Offering scalable and secure cloud solutions to streamline your business operations.",
      brandTag: ["Cloud Migration", "Data Security", "Scalability"],
      onclick: () => {
        navigate("/servicepage/cloudservices");
      },
      active: false,
    },
    {
      id: 5,
      icons: generate,
      title: "Generative AI",
      description: "Leveraging AI to create innovative solutions and automate complex processes.",
      brandTag: ["AI Models", "Automation", "Innovation"],
      onclick: () => {
        navigate("/servicepage/generativeai");
      },
      active: false,
    },
    {
      id: 6,
      icons: sap,
      title: "SAP Implementation & Support",
      description:
        "We specialize in ERP Consulting and SAP Practice. We offer tailored, cost-effective solutions for maintaining, supporting, and enhancing existing SAP applications with expertise in industry-specific",
      brandTag: ["ERP Consulting", "SAP Integration", "System Optimization"],
      onclick: () => {
        navigate("/servicepage/sapimplementation");
      },
      active: false,
    },
  ];

  return (
    <div className="service-step-card-container mainContainer">
      <div className="service-step-card-header">
        {stepsData.map((step) => (
          <>
            <div
              key={step.id}
              className="service-step-card"
              onClick={step.onclick}
              style={{ cursor: "pointer" }}
            >
              <div className="hover-content"></div>
              <div className="service-step-card-content">
                <img
                  src={step.icons}
                  alt="icon"
                  className="service-step-icon"
                  style={{
                    height: step.active ? "70px" : "auto",
                    width: step.active ? "70px" : "auto",
                  }}
                />

                <div className="service-step-text">
                  <h3 className="service-step-title">{step.title}</h3>
                  <p className="service-step-description">{step.description}</p>
                </div>
              </div>
              <div className="service-step-tags">
                {step.brandTag.map((tag, index) => (
                  <span key={index} className="service-step-tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <hr
              style={{
                border: "1px solid #fff",
                marginTop: ".5rem",
                marginBottom: ".5rem",
              }}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default Servicestep;
